import { useId } from "react";

import { ProductCard } from "../../../../domain/ProductCard.js";
import { Section } from "../../../../patterns/Section.js";
import { SectionHeader } from "../../../../patterns/SectionHeader.js";
import type { ProductsContent } from "../../homeContent.js";

/** Products to trade for or buy, in a grid; nothing for none. */
export function HomeProducts(products: ProductsContent) {
  const id = useId();
  if (products.items.length === 0) return null;
  return (
    <Section aria-labelledby={id} className="flex flex-col gap-6">
      <SectionHeader
        title={products.title}
        titleId={id}
        subtitle={products.subtitle}
        action={products.viewAll}
      />
      <ul className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-5 lg:grid-cols-6">
        {products.items.map(({ id: key, ...product }) => (
          <li key={key}>
            <ProductCard {...product} />
          </li>
        ))}
      </ul>
    </Section>
  );
}
